<main id="main" class="main">
  <div class="row">
    <div class="col-md-12">
      <h6 class="admintitle">
        Brochures&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>
  <!-- <div class="row">

    <img src="../../../assets//img/Marketing & Promotions.png">
  </div> -->
  <br>
  <div class="row">
    <!-- <div class="table-responsive mt-2" style="overflow-x: auto;"> -->
  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_1" class="table text-nowrap">
        <!-- <table
            class="table text-nowrap"> -->
        <thead>
          <tr>
            <!-- <th>S.no</th> -->
            <th>S.no</th>
            <th>Name</th>
            <th>Actions</th>

          </tr>
        </thead>

        <!-- <tbody> -->
        <tbody >
          <tr *ngFor="let broucher of broucherList; let i = index">

            <td>{{i+1}}</td>
            <td>{{broucher.name}}</td>

            <td style="cursor: pointer;">
              <i class="fa fa-eye" aria-hidden="true" title="view" data-bs-toggle="modal" data-bs-target="#ViewDisclousreAggrement" (click)="showBroucherFile(broucher)"></i>&nbsp; &nbsp;<i class="fa fa-download" aria-hidden="true" title="Download" (click)="downloadBroucher(broucher)"></i>

            </td>


          </tr>
        </tbody>

      </table>

    </div>


  </div>
</main>
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" id="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
    <iframe *ngIf="true" id="pdf-viewer" [src]="broucherPdfFile" [render-text]="true" [original-size]="false">
    </iframe>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div> -->

<div class="modal fade" data-bs-backdrop="static" id="ViewDisclousreAggrement" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 850px; margin-left: -100px">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
       
        <pdf-viewer *ngIf=true id="pdf-viewer" [src]="broucherPdfFile" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="closePopup('ViewDisclousreAggrement')">
          {{lang.Close}}
        </button> -->

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

